import {
    createBrowserRouter,
    RouterProvider
} from 'react-router-dom';


import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@flexinet/ui-components/style.css'


import {UserAttributesContextProvider} from "./context/UserAttributesContext.tsx";
import {theme} from "./theme.ts";
import {MantineProvider} from "@mantine/core";
import {Notifications} from "@mantine/notifications";
import {ModalsProvider} from "@mantine/modals";

import {AuthProvider} from "./context/AuthContext.tsx";
import {VerifiedPermissionsProvider} from './providers/VerifiedPermissionsProvider.tsx';
import {actions} from "./config/rbac/actions.ts";
import {
    CognitoContextProvider,
    createAuthAwareQueryClient,
    SessionGuardProvider
} from '@flexinet/auth-components';
import {routesConfig} from "./config/routes.tsx";
import {QueryClientProvider} from '@tanstack/react-query';
import {Provider} from 'react-redux';
import {store} from './store';

const router = createBrowserRouter(routesConfig)
// FNP-865: auth errors from queries reach the SessionGuardProvider below, which
// tries a forced token refresh and only then redirects to sign in.
const queryClient = createAuthAwareQueryClient();


// FNP-951: the Redux <Provider> sits here rather than in main.tsx (where the
// sibling apps put it) because main.tsx is owned by another initiative. It is
// the OUTERMOST wrapper, so every provider below can dispatch or read state.
// Redux has no ordering dependency on Mantine, the router or React Query —
// it neither consumes their context nor is consumed by them — so the nesting
// order is free and this placement is equivalent to wrapping <App/> itself.
export const App = () => {

    return (
        <Provider store={store}>
        <MantineProvider theme={theme}>
            <SessionGuardProvider>
            <QueryClientProvider client={queryClient}>
                <AuthProvider>
                    <VerifiedPermissionsProvider actions={actions}>
                        <UserAttributesContextProvider>
                            <CognitoContextProvider>
                                <ModalsProvider>
                                    <Notifications position={'bottom-left'}/>
                                    <RouterProvider router={router}/>
                                </ModalsProvider>
                            </CognitoContextProvider>
                        </UserAttributesContextProvider>
                    </VerifiedPermissionsProvider>
                </AuthProvider>
            </QueryClientProvider>
            </SessionGuardProvider>
        </MantineProvider>
        </Provider>
    );
}

